
import axios from '../../helpers/axios';


export const updatedModalContent = (id, updateModalContent) => axios.patch(`/modalContent/update/${id}`, updateModalContent)
export const deletedModalContent = (id) => axios.delete(`/modalContent/delete/${id}`)
